<div class="main-content">

  <!-- ─── HEADER (stesso design di /damage-overview) ─── -->
  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--orange">
        <i class="fas fa-user-check"></i>
      </div>
      <div>
        <h1 class="main-title">Pratiche Assegnate a Me</h1>
        <p class="main-subtitle">
          Visualizza e gestisci le pratiche danno a tuo carico.
        </p>
      </div>
    </div>

    <app-damage-nav-box></app-damage-nav-box>

    <!-- Strumentario -->
    <div class="toolbox-container">
      <div class="toolbox-heading">
        <div class="toolbox-heading-icon">
          <i class="fas fa-tools"></i>
        </div>
        <div class="toolbox-heading-text">
          <span class="toolbox-title">Strumentario</span>
          <small class="toolbox-subtitle">Strumenti rapidi</small>
        </div>
      </div>
      <div class="toolbox-divider"></div>
      <div class="toolbox-buttons">
        <!-- Aggiorna dati -->
        <button type="button" class="toolbox-btn toolbox-btn--green" (click)="load()"
                [disabled]="isLoading" title="Aggiorna le pratiche assegnate">
          <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
        </button>

        <!-- Densità tabella -->
        <button type="button" class="toolbox-btn toolbox-btn--orange" [class.active]="isCompactTable"
                (click)="toggleCompactTable()"
                title="Attiva/Disattiva la vista compatta della tabella">
          <i class="fas fa-grip-lines"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- ─── SEZIONE 1: RESOCONTO ─── -->
  <div class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-chart-bar header-icon"></i>
          <h3>Resoconto</h3>
          <span class="ad-count-pill">{{ damages.length }} {{ damages.length === 1 ? 'pratica' : 'pratiche' }}</span>
        </div>
        <!-- Toggle "Includi chiuse": stesso interruttore dei filtri di /damage-overview -->
        <div class="filter-input-wrapper damaged-filter-wrapper ad-closed-toggle">
          <i class="fas fa-flag-checkered filter-icon"></i>
          <span class="damaged-filter-text" [class.active]="includeClosed">
            {{ includeClosed ? 'Anche chiuse e respinte' : 'Solo pratiche aperte' }}
          </span>
          <button type="button" class="damaged-filter-switch"
                  role="switch" [attr.aria-checked]="includeClosed"
                  [class.active]="includeClosed"
                  [disabled]="isLoading"
                  (click)="setIncludeClosed(!includeClosed)"
                  [title]="includeClosed ? 'Mostra solo le pratiche aperte' : 'Includi anche le pratiche chiuse e respinte'">
            <span class="damaged-filter-switch-knob">
              <i class="fas" [ngClass]="includeClosed ? 'fa-folder' : 'fa-folder-open'"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="dmg-metrics-grid">

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--blue">
            <i class="fas fa-folder-open"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ openCount | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">Aperte</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--yellow">
            <i class="fas fa-cogs"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ inProgressCount | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">In lavorazione</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--orange">
            <i class="fas fa-hourglass-half"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ waitingCount | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">In attesa</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--red">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ overdueCount | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">Scadute</div>
          </div>
        </div>

        <div class="dmg-metric-card" *ngIf="includeClosed">
          <div class="dmg-metric-icon dmg-metric-icon--green">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ closedCount | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">Chiuse o respinte</div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- ─── SEZIONE 2: PRATICHE (stessa card, intestazione e barra di paginazione di /damage-overview) ─── -->
  <div id="table-section" class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-list header-icon"></i>
          <h3>Pratiche</h3>
        </div>
        <div class="d-flex align-items-center gap-3">

          <!-- Elementi per pagina -->
          <div class="btn-group btn-group-sm pagination-selector" role="group">
            <button type="button" class="btn" *ngFor="let n of [5, 10, 25, 50, 100]"
                    [ngClass]="itemsPerPage === n ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(n)" [title]="n + ' elementi per pagina'">
              {{ n }}
            </button>
          </div>

          <!-- Contatore -->
          <div class="counter-display">
            <span class="badge bg-light text-muted" title="Pratiche assegnate">
              <i class="fas fa-folder-open me-1"></i>
              {{ totalRecords | number }}
            </span>
          </div>

        </div>
      </div>
    </div>
    <div class="card-body p-0 results-table-body" [class.table-compact]="isCompactTable">

      <!-- Overlay di caricamento (solo su dati già presenti) -->
      <div class="table-loading-overlay" *ngIf="isLoading && damages.length > 0">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Caricamento...</span>
        </div>
      </div>

      <!-- Errore -->
      <div class="empty-state text-center" *ngIf="errorMessage && !isLoading">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-exclamation-triangle fa-3x text-warning"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Errore nel caricamento delle pratiche assegnate</h5>
        <p class="empty-state-subtitle text-muted small mb-0">{{ errorMessage }}</p>
        <button type="button" class="btn btn-primary btn-sm mt-3" (click)="load()">
          <i class="fas fa-redo-alt me-1"></i> Riprova
        </button>
      </div>

      <!-- Caricamento in corso (nessun dato ancora) -->
      <div class="empty-state text-center" *ngIf="damages.length === 0 && isLoading">
        <div class="empty-state-icon mb-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Caricamento...</span>
          </div>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Caricamento delle pratiche assegnate...</h5>
      </div>

      <!-- Nessuna pratica -->
      <div class="empty-state text-center"
           *ngIf="hasLoaded && damages.length === 0 && !isLoading && !errorMessage">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-clipboard-check fa-3x text-muted"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Nessuna pratica assegnata</h5>
        <p class="empty-state-subtitle text-muted small mb-0">
          {{ includeClosed ? 'Non risultano pratiche danno a tuo carico.' : 'Non hai pratiche danno aperte in carico. Attiva "Anche chiuse e respinte" per vedere lo storico.' }}
        </p>
      </div>

      <!-- Tabella -->
      <div class="table-responsive" *ngIf="damages.length > 0">
        <table class="table dmg-table mb-0">
          <thead>
            <tr>
              <th style="width: 60px;">#</th>
              <th *ngFor="let col of columns"
                  [class.sortable-th]="col.sortable"
                  (click)="col.sortable && sortBy(col.key)"
                  [title]="col.sortable ? 'Clicca per ordinare' : ''">
                {{ col.label }}
                <i *ngIf="col.sortable" [class]="getSortIcon(col.key)"></i>
              </th>
              <th>Azione</th>
            </tr>
          </thead>
          <tbody>
            <tr class="dmg-row ad-row" *ngFor="let damage of pagedDamages; let i = index; trackBy: trackByDamage"
                [class.ad-row--overdue]="isOverdue(damage)"
                (click)="openDetail(damage)">
              <td class="text-muted">{{ rowNumber(i) }}</td>
              <td *ngFor="let col of columns"
                  [class.dmg-code]="col.type === 'text'"
                  [class.dmg-date]="col.type === 'date'"
                  [ngSwitch]="col.type">
                <ng-container *ngSwitchCase="'date'">
                  <ng-container *ngIf="dateValue(damage, col); else emptyCell">
                    {{ dateValue(damage, col) | date:'dd/MM/yy HH:mm' }}
                    <i class="fas fa-exclamation-circle text-danger ms-1" *ngIf="col.key === 'damageDueDate' && isOverdue(damage)" title="Scadenza superata"></i>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'status'">
                  <span class="dmg-badge" [ngClass]="statusBadgeClass(damage.damageStatus)">
                    {{ damage.damageStatus ? ('DAMAGES.STATUS.' + damage.damageStatus | translate) : '-' }}
                  </span>
                </ng-container>
                <ng-container *ngSwitchCase="'severity'">
                  <span class="dmg-badge" [ngClass]="severityBadgeClass(damage.damageSeverity)">
                    {{ damage.damageSeverity ? ('DAMAGES.SEVERITY.' + damage.damageSeverity | translate) : '-' }}
                  </span>
                </ng-container>
                <ng-container *ngSwitchCase="'client'">{{ clientName(damage) || '-' }}</ng-container>
                <ng-container *ngSwitchDefault>
                  <ng-container *ngIf="cellValue(damage, col) != null && cellValue(damage, col) !== ''; else emptyCell">{{ cellValue(damage, col) }}</ng-container>
                </ng-container>
              </td>
              <td>
                <button type="button" class="dmg-claim-btn dmg-claim-btn--manage"
                        (click)="$event.stopPropagation(); openDetail(damage)"
                        [title]="'Apri la pratica danno #' + damage.damageId">
                  <i class="fas fa-folder-open me-1"></i>Gestisci
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginazione (stessa barra di /damage-overview, sempre visibile quando ci sono righe) -->
      <div class="pagination-container" *ngIf="totalRecords > 0 && !errorMessage">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(1)"
                  [disabled]="currentPage === 1" aria-label="Prima pagina" title="Prima pagina">
            <i class="fas fa-angles-left"></i>
          </button>

          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)"
                  [disabled]="currentPage === 1" aria-label="Precedente" title="Precedente">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <ng-container *ngFor="let page of getPageItems(); trackBy: trackByPageItem">
              <span class="pagination-ellipsis" *ngIf="page === null">…</span>
              <button *ngIf="page !== null"
                      class="pagination-number"
                      [class.active]="page === currentPage"
                      (click)="onPageChange(page)"
                      [attr.aria-label]="'Pagina ' + page"
                      [title]="'Vai alla pagina ' + page">
                {{ page }}
              </button>
            </ng-container>
          </div>

          <!-- Vai a pagina -->
          <div class="page-jump">
            <button class="pagination-btn" *ngIf="!isPageJumpOpen" (click)="openPageJump()"
                    aria-label="Vai a pagina" title="Vai a pagina...">
              <i class="fas fa-hashtag"></i>
            </button>
            <div class="page-jump-field" *ngIf="isPageJumpOpen">
              <input #pageJumpInput type="number" class="page-jump-input" min="1"
                     [max]="totalPages" [value]="pageJumpValue" [placeholder]="' / ' + totalPages"
                     (input)="pageJumpValue = $any($event.target).value"
                     (keydown.enter)="applyPageJump()" (keydown.escape)="closePageJump()" (blur)="closePageJump()">
              <button type="button" class="page-jump-go"
                      (mousedown)="$event.preventDefault()" (click)="applyPageJump()"
                      aria-label="Vai" title="Vai alla pagina">
                <i class="fas fa-level-down-alt fa-rotate-90"></i>
              </button>
            </div>
          </div>

          <span class="pagination-info">
            {{ rangeStart }} - {{ rangeEnd }} di {{ totalRecords }}
          </span>

          <!-- Vai all'elemento -->
          <div class="page-jump">
            <button class="pagination-btn" *ngIf="!isItemJumpOpen" (click)="openItemJump()"
                    aria-label="Vai a elemento" title="Vai all'elemento numero...">
              <i class="fas fa-list-ol"></i>
            </button>
            <div class="page-jump-field" *ngIf="isItemJumpOpen">
              <input #itemJumpInput type="number" class="page-jump-input" min="1"
                     [max]="totalRecords" [value]="itemJumpValue" [placeholder]="' / ' + totalRecords"
                     (input)="itemJumpValue = $any($event.target).value"
                     (keydown.enter)="applyItemJump()" (keydown.escape)="closeItemJump()" (blur)="closeItemJump()">
              <button type="button" class="page-jump-go"
                      (mousedown)="$event.preventDefault()" (click)="applyItemJump()"
                      aria-label="Vai" title="Vai all'elemento">
                <i class="fas fa-level-down-alt fa-rotate-90"></i>
              </button>
            </div>
          </div>

          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                  [disabled]="currentPage === totalPages" aria-label="Successivo" title="Successivo">
            <i class="fas fa-chevron-right"></i>
          </button>

          <button class="pagination-btn" (click)="onPageChange(totalPages)"
                  [disabled]="currentPage === totalPages" aria-label="Ultima pagina" title="Ultima pagina">
            <i class="fas fa-angles-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #emptyCell><span class="text-muted">-</span></ng-template>
